import { Component, Input } from '@angular/core';
import { TaskItem } from '../taskcommon/taskcommon.class';

@Component({
    selector: 'cp-taskcharts',
    templateUrl: './taskcharts.component.html',
    styleUrls: ['./taskcharts.component.css'],
    standalone: false
})
export class TaskChartsComponent {

  @Input() taskitem: TaskItem;
  @Input() hiddenCharts: boolean;
}
